// Textos de Marketing › Notificaciones push (envío manual a usuarios concretos).
// Se registran junto al resto de vocabularios en AppComponent; setTranslation
// los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    PUSH_NOTIFICATIONS: {
      NOTE_TITLE: 'Notificació push escrita a mà per a usuaris concrets',
      NOTE_TEXT:
        'S’envia com a notificació operativa, sense poder triar la categoria, i amb una petició per usuari. «Acceptada pel servidor» no vol dir «lliurada»: si l’usuari no té dispositius o ha desactivat aquestes notificacions, no li arriba.',
      RECIPIENTS_TITLE: 'Destinataris',
      RECIPIENTS_SUB:
        'Fins a {{max}} usuaris per enviament. Cerca’ls per nom, correu o telèfon.',
      RECIPIENTS_COUNT: 'Triats: {{count}} de {{max}}',
      RECIPIENTS_EMPTY: 'Encara no has triat cap usuari.',
      RECIPIENTS_MAX:
        'Ja tens el màxim de {{max}} destinataris. Treu-ne algun per afegir-ne un altre.',
      RECIPIENTS_LIST_ARIA: 'Destinataris triats',
      REMOVE: 'Treure',
      REMOVE_ARIA: 'Treure {{name}}',
      MESSAGE_TITLE: 'Missatge',
      MESSAGE_SUB: 'El que veurà l’usuari a la notificació.',
      FIELD_TITLE: 'Títol',
      FIELD_TITLE_PLACEHOLDER: 'P. ex.: Canvis en el teu viatge de demà',
      FIELD_BODY: 'Text',
      FIELD_BODY_PLACEHOLDER: 'Escriu el missatge de la notificació',
      SEND: 'Enviar',
      SENDING: 'Enviant {{done}} de {{total}}…',
      SEND_DISABLED_RECIPIENTS: 'Tria almenys un destinatari per poder enviar',
      SEND_DISABLED_TITLE: 'Escriu el títol per poder enviar',
      SEND_DISABLED_BODY: 'Escriu el text per poder enviar',
      CONFIRM_TITLE: 'Enviar push (destinataris: {{count}})',
      CONFIRM_TEXT:
        'S’envia a cada usuari per separat. No tanquis la pàgina fins que acabi.',
      CONFIRM_OK: 'Enviar',
      CONFIRM_CANCEL: 'Cancel·lar',
      RESULT_OK: 'Acceptades pel servidor: {{ok}} de {{total}}',
      RESULT_FAILED: 'No s’han pogut enviar: {{count}}',
      RESULT_FAILED_HINT:
        'Es queden com a destinataris, amb el mateix missatge, perquè puguis tornar-ho a provar.',
      ERROR_UNKNOWN: 'El servidor no n’ha donat el motiu.',
    },
  },
};
